import React, { useEffect, useState } from "react";
// react google recaptcha
import ReCAPTCHA from "react-google-recaptcha";
// formik
import { Form, Formik } from "formik";
// react router dom
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue } from "recoil";

// recoil atom and action
import { useAuthActions } from "../../_actions/auth";
import { authAtom } from "../../shared/auth";

// components
import InputField from "../../components/InputField/InputField";
import Typography from "../../components/Typography/Typography";
import Button from "../../components/Button/Button";
// validation
import { validationSchema } from "../../validations/validationForm";
// styled components
import { Img, Left, LoginForm, Right } from "./loginPageStyle";
// image background
import bg from "../../assets/images/IMG_2290.JPG";
import { recaptchaAtom } from "../../shared/recaptcha";
import { errorMessage } from "../../utils/message";

const LoginPage = () => {
  const [counterRequest, setCounterRequest] = useRecoilState(recaptchaAtom);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const navigate = useNavigate();

  const auth = useRecoilValue(authAtom);
  const userActions = useAuthActions();

  const initialValues = {
    Phone: "",
    password: "",
  };

  const onChange = (value) => {
    setRecaptchaToken(value);
  };

  const onSubmit = (values) => {
    userActions.userLogin(navigate, values).catch((err) => {
      errorMessage("شماره یا رمز کاربری اشتباه است.");
    });
    setCounterRequest(counterRequest + 1);
  };

  useEffect(() => {
    if (auth) {
      navigate("/dashboard", { replace: true });
    }
  }, []);

  return (
    <LoginForm>
      <Right>
        <Typography size="22px">به پنل CRM سلامت خوش آمدید</Typography>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          <Form>
            <InputField
              name="Phone"
              type="number"
              label="شماره تماس"
              id="Phone"
              placeholder="شماره تماس خود را وارد کنید"
            />
            <InputField
              name="password"
              type="password"
              label="رمز عبور"
              id="password"
              placeholder="رمز عبور خود را وارد کنید"
            />
            {counterRequest === 2 && (
              <ReCAPTCHA
                sitekey="6LeMG3IfAAAAAMQTfY4xzOrAFTGVf-ikL2vN-MaW"
                onChange={onChange}
              />
            )}
            <Button small="100px" bgColor="#009ef7" color="#fff">
              تایید
            </Button>
          </Form>
        </Formik>
      </Right>
      <Left>
        <Img src={bg} alt="image" />
      </Left>
    </LoginForm>
  );
};

export default LoginPage;
